<template>
    <header class="ms-main-header">
        <font-awesome-icon
            v-if="showMenuToggle"
            :icon="menuIcon"
            class="menu-toggle-button"
            size="lg"
            style="z-index: 1001;"
            @click.stop="$emit('toggleMenu')"
        />
        <v-chip
            v-if="
                $auth.impersonating &&
                ($auth['user']['https://memoryshare.com/roles'].includes('SuperAdmin') ||
                    $auth['user']['https://memoryshare.com/roles'].includes('Owner'))
            "
            class="ml-4"
            color="primary"
            variant="outlined"
            ><font-awesome-icon
                class="pa-1"
                :icon="$auth.impersonationTarget === 'Owner' ? 'fa-regular fa-suitcase fa-fw' : 'fa-solid fa-user fa-fw'"
            />
            {{ globalState.impersonatingName }}</v-chip
        >

        <span style="flex: 1"></span>
        <v-btn v-if="shouldDisplayToken" class="token-button" variant="plain" @click="copyTokenToClipboard()">TOKEN</v-btn>
        <div v-if="globalState.streaming">
            <router-link :to="{ name: 'LiveDashboard' }" class="live-container">
                <div class="blob"></div>
                <span class="mr-3">LIVE</span>
            </router-link>
        </div>

        <div v-if="$auth.impersonating" class="d-inline-block mr-md-8" @click="returnToAdmin">
            <p class="pointer my-0" style="font-size: 0.9rem">
                <font-awesome-icon icon="fa-solid fa-arrow-left" class="fa-fw" />
                <span>Back to {{ $auth.user.name }}</span>
            </p>
            <small
                v-if="$auth['user']['https://memoryshare.com/roles'].includes('SuperAdmin')"
                style="position: absolute; margin-left: 1.9rem; line-height: .8;"
                >{{
                    $auth.impersonationTarget === 'Owner'
                        ? `Owner Id: ${$auth.ownerId}`
                        : `Funeral Home Id: ${$auth.funeralHomeId}`
                }}</small
            >
        </div>
        <span v-else class="header-username">Hello, {{ globalState.loggedInUser }}</span>
        <div class="d-inline-block ml-4" style="z-index: 1001">
            <v-menu offset-y>
                <template #activator="{ props }">
                    <span v-bind="props">
                        <font-awesome-icon icon="fa-regular fa-circle-user" size="2xl" />
                    </span>
                </template>
                <v-list class="dropdown">
                    <v-list-item
                        v-if="!($auth.role.includes('SuperAdmin') || $auth.role.includes('RegionalManager'))"
                        @click="goToSettings"
                    >
                        <font-awesome-icon icon="fa-regular fa-gear" class="mr-4" />
                        <span>Settings</span>
                    </v-list-item>
                    <v-list-item
                        v-if="$auth.role.includes('FuneralHome') || $auth.role.includes('Supplier')"
                        @click="getUsers"
                    >
                        <font-awesome-icon icon="fa-regular fa-circle-user" class="mr-4" />
                        <span>Manage Users</span>
                    </v-list-item>
                    <v-list-item
                        v-if="
                            !$auth.role.includes('SuperAdmin') &&
                            !$auth.role.includes('Supplier') &&
                            !$auth.impersonating
                        "
                        @click="getEditInfo"
                    >
                        <font-awesome-icon icon="fa-regular fa-circle-user" class="mr-4" />
                        <span>Edit Profile</span>
                    </v-list-item>
                    <v-list-item @click="logout">
                        <font-awesome-icon icon="fa-solid fa-right-from-bracket" class="mr-4" />
                        <span>Logout</span>
                    </v-list-item>
                </v-list>
            </v-menu>
        </div>
        <div style="position: absolute">
            <UsersTable ref="usersTable"></UsersTable>
            <EditProfileTable ref="EditProfileTable"></EditProfileTable>
        </div>
    </header>
</template>
<script>
import UsersTable from '@/components/Tables/UsersTable.vue';
import EditProfileTable from '@/components/Tables/EditProfileTable.vue';
import { mapActions } from 'pinia';
import { useGlobalState } from '@/stores/globalState';
export default {
    components: {
        UsersTable,
        EditProfileTable,
    },
    props: {
        menuOpen: {
            type: Boolean,
            default: false,
        },
        showMenuToggle: {
            type: Boolean,
            default: true,
        },
    },
    setup() {
        return {
            globalState: useGlobalState(),
        }
    },
    data: function () {
        return {};
    },
    methods: {
        ...mapActions(useGlobalState, ['showSnackbar']),
        async copyTokenToClipboard() {
            const token = await this.$auth.getTokenSilently();
            if (token) {
                const el = document.createElement('textarea');
                el.value = 'Bearer ' + token;
                document.body.appendChild(el);
                el.select();
                document.execCommand('copy');
                document.body.removeChild(el);
                this.showSnackbar({ message: 'Token copied to clipboard' });
            }
        },
        goToSettings() {
            if (this.$auth.role.includes('Owner')) {
                let owner_id = this.$auth.user['https://memoryshare.com/owner_id'];
                this.$router.push(`/owner-settings/${owner_id}?tab=details`);
            } else if (this.$auth.role.includes('Supplier')) {
                this.$router.push(`/suppliers/edit/${this.$auth.session.supplier.id}`);
            } else {
                this.$router.push('/settings');
            }
        },
        getEditInfo() {
            this.$refs.EditProfileTable.openDialog = true;
            this.$refs.EditProfileTable.getUsers(true);
        },
        getUsers() {
            this.$refs.usersTable.openDialog = true;
            this.$refs.usersTable.getUsers(true);
        },
        logout() {
            this.$auth.logout({
                logoutParams: {
                    returnTo: window.location.origin
                }
            });
        },
        returnToAdmin() {
            this.$api
                .post('/superadmin/impersonate', {
                    funeralHomeId: 0,
                    impersonate: false,
                })
                .then(async response => {
                    this.globalState.updateImpersonatingName('');
                    await this.$router.push({ name: 'Services' });
                    this.$router.go(0);
                });
        },
        checkLive() {
            this.$api
                .get('/live/get-live-count')
                .then(response => {
                    if (response.data > 0) {
                        this.globalState.toggleStreaming(true);
                    } else {
                        this.globalState.toggleStreaming(false);
                    }
                })
                .catch(error => {
                    console.log(error);
                });
        },
    },
    computed: {
        shouldDisplayToken() {
            return (
                this.$auth.role.includes('SuperAdmin') ||
                this.$auth.impersonating === true ||
                window.location.hostname === 'develop.memoryshare.com' ||
                window.location.hostname === 'localhost' ||
                window.location.hostname === '127.0.0.1'
            );
        },
        menuIcon() {
            return this.menuOpen ? 'fa-solid fa-close' : 'fa-solid fa-bars';
        }
    },
    mounted() {
        this.checkLive();
    },
};
</script>
<style lang="scss">
/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (max-width: 768px) {
    .token-button,
    .header-username {
        display: none;
    }
}
</style>
